export default "__VITE_ASSET__6187ee6c__"